var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoach = function SvgCoach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.787 16.773",
    stroke: "#b6bbcc",
    strokeWidth: 1
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1352.606 -435)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.894,
    cy: 5.894,
    rx: 5.894,
    ry: 5.894,
    transform: "translate(1353.606 438.985)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9v3.437l1.023,1.718",
    transform: "translate(1347.5 432.439)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.705,
    transform: "translate(1359.5 435)",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2.47,
    x2: 2.47,
    transform: "translate(1361.97 437.47)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.47,
    y1: 2.47,
    transform: "translate(1354.561 437.47)",
    fill: "none"
  }))));
};
export default SvgCoach;